<template>
    <div>
        <b-card :header="$t('general.projects.progress.periodical_analysis.title')" header-tag="h3">
            <b-card>
                <periodical-analysis 
                    :tableName="tableName"
                    :columnData="table.columnData"
                    :topTableHeader="table.topTableHeader"
                    :topTableHeaderData="table.topTableHeaderData"
                    :tableHeader="table.tableHeader"
                    :tableHeaderData="table.tableHeaderData"
                    @onLoadTable="onLoadTable"
                >
                </periodical-analysis>
            </b-card>
            
            <periodical-analysis-charts-other-discipline-equipment
                v-if="showCharts"
                :rowData="rowData"
            >
            </periodical-analysis-charts-other-discipline-equipment>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import PeriodicalAnalysis from '@/components/pages/project/percent_progress/common/tables/periodical_analysis.vue';
import PeriodicalAnalysisChartsOtherDisciplineEquipment from '@/components/pages/project/percent_progress/other_discipline/equipment/periodical_analysis/periodical_analysis_charts_other_discipline_equipment.vue';

export default {
    name: 'periodical_analsysis_other_discipline_equipment',
    components: {
        PeriodicalAnalysis,
        PeriodicalAnalysisChartsOtherDisciplineEquipment,
    },
    data() {
        return {
            rowData: [],
            showCharts: false,
            tableName: 'progress_other_discipline_equipment_periodical_analysis',
            table: {
                columnData: [
                    {
                        label: Vue.i18n.translate('table.step_no'),
                        field: 'step_no',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.date_of_progress_measurement'),
                        field: 'step_date',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.step_calendar'),
                        field: 'step_calendar',
                        numeric: false,
                        html: false,
                    },
                    //Progress from Total Execution Value estimate
                    {
                        label: Vue.i18n.translate('table.cummulated_progress'),
                        field: 'progress_from_total_execution_calculation_cummulated_progress',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.progress_week'),
                        field: 'progress_from_total_execution_calculation_progress_week',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.cummulated_progress'),
                        field: 'progress_from_total_execution_status_cummulated_progress',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.progress_week'),
                        field: 'progress_from_total_execution_status_progress_week',
                        numeric: false,
                        html: false,
                    },
                    //Progress from Current Available Execution Value
                    {
                        label: Vue.i18n.translate('table.cummulated_progress'),
                        field: 'progress_from_current_available_calculation_cummulated_progress',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.progress_week'),
                        field: 'progress_from_current_available_calculation_progress_week',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.cummulated_progress'),
                        field: 'progress_from_current_available_status_cummulated_progress',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.progress_week'),
                        field: 'progress_from_current_available_status_progress_week',
                        numeric: false,
                        html: false,
                    },
                    //Current Execution Value Work Drawings
                    {
                        label: Vue.i18n.translate('table.current_execution_value_work_drawings'),
                        field: 'current_execution_value_work_drawings',
                        numeric: false,
                        html: false,
                    },
                ],
                //First Header
                topTableHeader: true,
                topTableHeaderData: {
                    start: 2,
                    values: [
                        //Progress from Total Execution Value estimate
                        {
                            text: 'general.projects.progress.progress_total_execution_chart.title',
                            colspan: 4,
                            class: 'bg-primary text-white'
                        },
                        {
                            text: 'general.projects.progress.progress_current_available_chart.title',
                            colspan: 4,
                            class: 'bg-info text-white'
                        },
                    ]
                },
                //Second Header
                tableHeader: true,
                tableHeaderData: {
                    start: 2,
                    values: [
                        //Progress from Total Execution Value estimate
                        {
                            text: 'table.based_on_calculation',
                            colspan: 2,
                        },
                        {
                            text: 'table.based_on_status',
                            colspan: 2,
                        },
                        //Progress from Current Available Execution Value
                        {
                            text: 'table.based_on_calculation',
                            colspan: 2,
                        },
                        {
                            text: 'table.based_on_status',
                            colspan: 2,
                        },
                    ]
                }
            }
        }
    },
    methods: {
        onLoadTable (response) {
            //Show charts after table is loaded
            this.rowData    = response.data;
            this.showCharts = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/other_discipline/equipment/periodical_analysis/periodical_analsysis_other_discipline_equipment.vue